module.exports = __webpack_public_path__ + "static/img/map.c3accf6e.png";